import React from 'react';
import ButtonLink from '@teetsh/app/src/components/Buttons/Link';
import { BoltIcon as LightningBolt } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

interface Props {
  large?: boolean;
  outlined?: boolean;
}

export function PremiumButton(props: Props) {
  const { large, outlined } = props;
  const { t } = useTranslation(['common']);
  return (
    <ButtonLink
      to="/pricing"
      intent="primary"
      outlined={outlined}
      large={large}
      icon={LightningBolt}
    >
      {t('common:buttons.upgradeToUnlimited')}
    </ButtonLink>
  );
}
